import React from "react";
import { css } from "@emotion/react";

import { devices, colors } from "../assets/styles/variables";

const comicSliderArrow = css`
  position: fixed;
  top: calc(50% - 30px);
  z-index: 10;
  display: none;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: ${colors.black};
  cursor: pointer;

  @media screen and (min-width: ${devices.mobile}) {
    display: block;
  }

  &:before {
    position: absolute;
    top: calc(50% - 11px);
    display: block;
    width: 18px;
    height: 18px;
    border-top: 3px solid ${colors.white};
    border-left: 3px solid ${colors.white};
    content: "";
  }

  &.prev {
    right: 20px;
    height: 60px;
    &:before {
      left: calc(50% - 14px);
      transform: rotate(135deg);
    }
  }

  &.next {
    left: 20px;
    height: 60px;
    &:before {
      left: calc(50% - 4px);
      transform: rotate(-45deg);
    }
  }

  &.hidden {
    display: none;
  }
`;

interface Props {
  isPrev: boolean;
  isShown: boolean;
  onClick?: Function;
}

const ComicSliderArrow = (props: Props) => {
  const { onClick, isPrev, isShown } = props;

  const handleClickArrow = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      css={comicSliderArrow}
      className={`${isPrev ? "prev" : "next"} ${!isShown && "hidden"}`}
      onClick={() => handleClickArrow()}
    ></div>
  );
};

export default ComicSliderArrow;
